import React from 'react';

import styled from 'styled-components';

import { FeeDataType } from 'types/fees';
import { formatPrice, isNonNegativeNumber } from 'utils/helpers/numbers';
import { raiseUnderscore } from 'utils/helpers/string';

import { FEES_LEVELS_FIELDS } from '../../../ShopData/constants';

const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 40px;
`;

const LevelContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LevelName = styled.div`
  font-size: 10px;
  color: var(--text-primary);
`;

const LevelValue = styled.div`
  font-size: 12px;
  color: var(--positive-green);
`;

type Props = {
  fee?: FeeDataType;
};

const FeesLevels = ({ fee }: Props) => {
  const levelKeys = Object.values(FEES_LEVELS_FIELDS);

  return (
    <Container data-test-id="cd-community-care-fees-levels">
      {(levelKeys as Array<keyof FeeDataType>)
        .filter((level) => fee && isNonNegativeNumber(fee[level]))
        .map((level, index) => {
          const dataKey = `cd-community-care-fees-levels-${raiseUnderscore(level)}`;
          const dataKeyValue = `${dataKey}-value`;
          const value = fee?.[level];
          return (
            <LevelContainer key={`level_${index}`} data-test-id={dataKey}>
              <LevelName>{`Lv. ${level.slice(-1)}`}</LevelName>
              <LevelValue data-test-id={dataKeyValue}> {typeof value === 'number' ? formatPrice(value, '$') : ''}</LevelValue>
            </LevelContainer>
          );
        })}
    </Container>
  );
};

export default FeesLevels;
